module.exports = __webpack_public_path__ + "img/6en.27243633.png";